<script>
import UiInput from '../ui/Input';
import UiButton from '../ui/Button';
import deepEqual from 'deep-equal';
import { store } from '../../functions/mixins';
import * as sdk from '../../functions/sdk';

async function getBase64FromImageUrl(imageUrl) {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}

export default {
    mixins: [store],
    props: {
        value: Object,
        next: Function,
        disableNext: Boolean,
        showSuccess: Boolean,
        successData: Object,
    },
    components: {
        UiInput,
        UiButton,
    },
    data: () => ({
        data: null,
    }),
    computed: {
        forceAndroid() {
            return !!this.$route.query.forceAndroid;
        },
        isSenderReadonly() {
            if (this.isEditorAccount) {
                return true;
            }
            return !!this.userInfo.readOnlyTitle;
        },
    },
    created() {
        this.data = Object.assign({}, this.value);
        if (this.data.isModNews) {
            const fetchBackgrounds = async () => {
                try {
                    const android = (await sdk.pressengerControl.getNotificationImages()).sort((a, b) => b.id - a.id);
                    const ios = await sdk.pressengerControl.getiOSLogos();
                    const combined = {};
                    for (let i = 0; i < android.length; i++) {
                        if (android[i].fileName.indexOf('android_modnewsbackground') > -1) {
                            combined[android[i].fileName.split('_')[0]] = {
                                android: await getBase64FromImageUrl(sdk.getNotificationImageURL(android[i].groupId, android[i].fileName)),
                                ios: null,
                            };
                        }
                    }
                    for (let i = 0; i < ios.length; i++) {
                        if (ios[i].fileName.indexOf('ios_modnewsbackground') > -1 && combined[ios[i].fileName.split('_')[0]]) {
                            combined[ios[i].fileName.split('_')[0]]['ios'] = await getBase64FromImageUrl(sdk.getIOSExtendedNotificationURL(ios[i].groupId, ios[i].fileName));
                        }
                    }
                    this.data.modNewsBackgrounds = combined;
                } catch (e) {
                    console.log(e);
                    console.log('No mod-news background.');
                }
            };
            fetchBackgrounds();
        }
    },
    methods: {
        refreshPage() {
            window.location.reload();
        },
    },
    watch: {
        value: {
            deep: true,
            handler(nextVal) {
                if (!deepEqual(nextVal, this.data)) {
                    this.data = Object.assign({}, nextVal);
                }
            }
        },
        data: {
            deep: true,
            handler: function(nextVal) {
                if (!deepEqual(nextVal, this.value)) {
                    this.$emit('input', Object.assign({}, nextVal));
                }
            }
        },
    },
}
</script>

<template>
    <div class="StepInfo" :style="`max-width: ${data.isModNews ? '1170px' : '600px'};`">
        <template v-if="showSuccess">
            <div class="Alert AlertSuccess">
                <template v-if="successData.type === 'sent'">
                    {{ $t('stepInfo.successMessage') }}
                </template>
                <template v-else-if="successData.type === 'delayed'">
                    {{ $t('stepInfo.successMessageAlt') }}
                </template>
                <!--template v-else-if="successData.type === 'export'"-->
                    {{ $t('stepInfo.successMessageExport') }}
                    <strong>{{ successData.pressageId }}</strong>
                <!--/template-->
            </div>
            <div>
                <ui-button
                    @click.native="refreshPage()"
                    class="semibig altpadding"
                >{{ $t('stepInfo.sendAnother') }}</ui-button>
            </div>
        </template>
        <template v-else>
            <div class="StepInfoInputWrapper">
                <div class="StepInfoInputWrapperInner">
                    <ui-input
                        v-model="data.title"
                        :label="$t('stepInfo.titleLabel')"
                        class="StyleAlt"
                        :popup="$t('stepInfo.titleHint')"
                        :debounce="400"
                        @keydown.native.enter="!disableNext && next()"
                    />
                    <!--
                    <ui-input
                        v-model="data.sender"
                        :label="$t('stepInfo.senderLabel')"
                        class="StyleAlt PT0"
                        :popup="$t('stepInfo.senderHint')"
                        :debounce="400"
                        @keydown.native.enter="!disableNext && next()"
                        :readonly="isSenderReadonly"
                    />
                    -->
                    <ui-input
                        v-model="data.notificationText"
                        v-if="!isAndroidOnly && !forceAndroid"
                        type="textarea"
                        :label="$t('stepInfo.notificationTextLabel')"
                        class="StyleAlt PT0"
                        :popup="$t('stepInfo.notificationTextHint')"
                        :debounce="400"
                        :labelTop="true"
                    />
                </div>
                <div v-if="data.isModNews" class="StepInfoInputWrapperInner">
                    <ui-input
                        v-model="data.modNewsTemplate"
                        :label="$t('modNews.template')"
                        class="StyleAlt"
                        :debounce="400"
                        type="select"
                        @keydown.native.enter="!disableNext && next()"
                        :items="[{
                            value: 'basic',
                            title: $t('modNews.templateText')
                        }, {
                            value: 'textImage',
                            title: $t('modNews.templateTextImage')
                        }]"
                    />
                    <ui-input
                        v-model="data.modNewsText"
                        type="textarea"
                        :label="$t('modNews.text')"
                        class="StyleAlt PT0"
                        :debounce="400"
                        :labelTop="true"
                    />
                </div>
            </div>
            <div :style="`${data.isModNews ? 'display: flex; justify-content: center' : 'margin-left: 40%'}`">
                <ui-button
                    @click.native="next()"
                    :disabled="disableNext"
                    class="semibig altpadding"
                >{{ $t('stepInfo.create') }}</ui-button>
            </div>
        </template>
    </div>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.StepInfo
    width 100%

    .StepInfoInputWrapper
        display flex
        flex-direction row
        .StepInfoInputWrapperInner
            flex 1 1 auto

.Alert
    background #fff
    border 1px solid $cBorder
    padding 20px
    margin-bottom 20px
    width 100%
    box-sizing border-box
    color $cPrimary
    &.AlertSuccess
        border-color $cSuccess
        background lighten($cSuccess, 80%)
        color $cSuccess
</style>
